import axios from "axios"
import { API } from "../constants/constants"

export const getNavigation = (p: { lang: string; context: string }) =>
    axios
        .get(API + p.lang + "/api/navigations/" + p.context, {
            params: {
                depth: 100,
                flat: false,
                excerpt: true,
            },
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
        })
        .then((res) => res.data)

export const getDynamicData = (p: { lang: string; slug: string }) => axios.get(API + p.lang + p.slug + ".json").then((res) => res.data)

export const getSnippetData = (p: { lang: string; snippet: string }) =>
    axios.get(API + p.lang + "/api/snippet-areas/" + p.snippet).then((res) => res.data)
